module.exports = __webpack_public_path__ + "media/images/top/feature_img_02-223e20a26a1ab9fb40b21d4164b359fc.png";